import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { FormStore } from '@estee/elc-form';

import { FormItemAdapter } from '~components/FormItemAdapter';
import { IFormItem } from '~domain/entities/Config';
import { IUserFormValues } from '~domain/entities/UserFormStore';

export interface ISectionGrid {
    items: IFormItem[];
    formStore: FormStore<IUserFormValues>;
    sectionName?: string;
}

export interface IGridAreaItem {
    name: string;
}

export const GridAreaItem = styled.div<IGridAreaItem>`
    grid-area: ${({ name }) => name};
`;

@observer
export class SectionGrid extends React.Component<ISectionGrid> {
    render() {
        const { items, sectionName = '', formStore } = this.props;
        const containerClasses = `elc-section-wrapper js-elc-section-wrapper elc-iam-section-${sectionName}-wrapper`;
        const TEST_ID_SECTION = `IAM_SECTION_${sectionName.toUpperCase()}`;

        return (
            <div className={containerClasses} data-test-id={TEST_ID_SECTION}>
                {items.map((item) => {
                    const { name } = item;
                    const itemClasses = `elc-form-field-wrapper js-elc-form-field-wrapper elc-iam-${name}-wrapper`;
                    const TEST_ID_ITEM = `IAM_ITEM_${name.toUpperCase()}`;

                    return (
                        <GridAreaItem
                            data-test-id={TEST_ID_ITEM}
                            className={itemClasses}
                            name={name}
                        >
                            <FormItemAdapter {...item} formStore={formStore} />
                        </GridAreaItem>
                    );
                })}
            </div>
        );
    }
}
